import { Td } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import { contractStatus } from 'utils';
import { engToKor } from 'utils';

function ContractTableRow(props) {
  const { data } = props;

  return (
    <>
      <Td>{data.id}</Td>
      <Td>{data.writer.name}</Td>
      <Td>{engToKor(data.paymentType)}</Td>
      <Td>{dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')}</Td>
      <Td>{contractStatus(data.status)}</Td>
      <Td>{data.admin?.name}</Td>
    </>
  );
}

export default ContractTableRow;
